import axios from 'axios'

export const createBillingPortal = (sam_plan_user_id) => {
    return axios.post('/stripe/checkout/sam/bill/portal', {
        sam_plan_user_id: sam_plan_user_id
    })
}

export const getPaymentMethods = (sam_plan_user_id) => {
    return axios.post('stripe/customer/sam/payments/methods', {
        sam_plan_user_id: sam_plan_user_id
    })
}

export const getCustomerInfo = (sam_plan_user_id) => {
    return axios.post('stripe/customer/sam/info', {
        sam_plan_user_id: sam_plan_user_id
    })
}

export const getCustomerInvoices = (sam_plan_user_id) => {
    return axios.post('stripe/customer/sam/payments/invoices', {
        sam_plan_user_id: sam_plan_user_id
    })
}